export default __webpack_public_path__ + "static/mobile-logo-157fa6261644231521bfa4202ff25ead.png";